import { useQuery } from "@tanstack/react-query";
import { Loader2 } from "lucide-react";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";
import NotFound from "@/pages/NotFound";
import { Navigate } from "react-router-dom";
import { usePlatformSettings } from "@/hooks/usePlatformSettings";

/** Server-checked platform admin gate. Anyone else sees the normal 404 page. */
export function AdminGate({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();
  const q = useQuery({
    queryKey: ["is-platform-admin", user?.id],
    enabled: !!user,
    queryFn: async () => {
      const { data, error } = await supabase.rpc("is_platform_admin" as any);
      return !error && data === true;
    },
  });
  if (loading || (user && q.isLoading)) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="w-6 h-6 animate-spin text-muted-foreground" />
      </div>
    );
  }
  if (!user || !q.data) return <NotFound />;
  return <>{children}</>;
}

/** Billing screens exist only while billing is switched on; otherwise send people Home. */
export function BillingRouteGate({ children }: { children: React.ReactNode }) {
  const { pricingEnabled, loading } = usePlatformSettings();
  if (loading) return null;
  if (!pricingEnabled) return <Navigate to="/home" replace />;
  return <>{children}</>;
}
